import {
  GET_ALL_PENALTY_SHOW_BY_USER,
  GET_LEAVE_BY_ID,
} from "@/GraphQL/Queries";
import imageUrl from "@/utils/api/imageUrl";
import { useQuery } from "@apollo/client";
import moment from "moment";
import React, { useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import { Pagination } from "@mui/material";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
export default function PenaltyRedZone({ penalties, user, user_id }) {
  const [modal, setModal] = useState(false);
  const [leaveId, setLeaveId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 5;
  const { data, loading, error, refetch } = useQuery(
    GET_ALL_PENALTY_SHOW_BY_USER,
    {
      variables: {
        user_id: user_id,
        page: currentPage,
        size: limit,
      },
      fetchPolicy: "network-only",
    }
  );
  console.log("🚀 ~ PenaltyRedZone ~ data:", data);
  const handleChange = (e, p) => {
    setCurrentPage(p);
    refetch({
      page: p,
    });
  };

  const leaveTypeList = [
    { value: 1, label: "Casual" },
    { value: 2, label: "Annual" },
    { value: 3, label: "Sick" },
    { value: 4, label: "Menstrual" },
    { value: 5, label: "Maternity" },
    { value: 6, label: "Reimburse" },
    {
      value: 101,
      label: `Work From Home`,
    },
    {
      value: 102,
      label: `On Field Duty`,
    },
    {
      value: 201,
      label: `On Leave`,
    },
  ];

  const { data: leaveData } = useQuery(GET_LEAVE_BY_ID, {
    variables: { id: leaveId },
    skip: !leaveId,
  });
  const selectedLeave = leaveData?.getLeaveById;

  const modalHandler = () => setModal((prev) => !prev);
  // if (loading) {
  //   return (
  //     <div className="loader-container">
  //       <SubmitLoading color="black" />
  //     </div>
  //   );
  // }

  if (!data?.getAllPenaltyShowByUser?.data.length && !loading) return null;

  return (
    <Card>
      <CardBody>
        <div
          style={{
            backgroundColor: "#f8d7da",
            color: "#721c24",
            border: "1px solid #f5c6cb",
            borderRadius: "4px",
            padding: "10px 15px",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}
        >
          🚨 Total Penalty:{" "}
          {data?.getAllPenaltyShowByUser?.paginatorInfo?.total} Day
          {data?.getAllPenaltyShowByUser?.paginatorInfo?.total > 1 ? "s" : ""}
        </div>

        <Table bordered striped responsive size="sm">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Leave Application</th>
            </tr>
          </thead>

          {loading ? (
            <tr>
              <td colSpan="8" className="text-center">
                <SubmitLoading color="black" />
              </td>
            </tr>
          ) : (
            <tbody>
              {data?.getAllPenaltyShowByUser?.data?.map((penalty, index) => (
                <tr key={penalty.id}>
                  <td>{index + 1}</td>
                  <td>{moment(penalty.penalty_date).format("MMMM D, YYYY")}</td>
                  <td>
                    {penalty.hasPendingLeave ? (
                      <button
                        onClick={() => {
                          setLeaveId(penalty.pendingLeaveId);
                          modalHandler();
                        }}
                        style={{
                          padding: "4px 8px",
                          borderRadius: "4px",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "0.875rem",
                        }}
                      >
                        ✅ Click to view
                      </button>
                    ) : (
                      "❌ Not Found"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </Table>

        {data?.getAllPenaltyShowByUser?.data.length > 0 ? (
          <Pagination
            className="mt-2"
            count={data?.getAllPenaltyShowByUser?.paginatorInfo?.lastPage}
            page={data?.getAllPenaltyShowByUser?.paginatorInfo?.currentPage}
            onChange={handleChange}
          />
        ) : null}

        <Modal toggle={modalHandler} isOpen={modal}>
          <ModalHeader toggle={modalHandler}>
            <div className="inbox__email-left">
              <div className="inbox__email-ava mr-3">
                <img
                  src={`${imageUrl}/users/${
                    data?.getAllPenaltyShowByUser?.data[0]?.penaltyUserInfo
                      ?.images ||
                    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                  }`}
                  // src={
                  //   user?.getAllPenaltyShowByUser[0]?.penaltyUserInfo?.images
                  //     ? user?.getAllPenaltyShowByUser[0]?.penaltyUserInfo
                  //         ?.images
                  //     : "https://www.kindpng.com/picc/m/24-248253_user-profile-default-image-png-clipart-png-download.png"
                  // }
                  alt="user"
                />
              </div>
              <div className="inbox__email-info">
                <h5 className="inbox__email-name" style={{ fontSize: 20 }}>
                  {
                    data?.getAllPenaltyShowByUser?.data[0]?.penaltyUserInfo
                      ?.name
                  }
                </h5>
                <p className="inbox__email-email mt-1" style={{ fontSize: 14 }}>
                  {
                    data?.getAllPenaltyShowByUser?.data[0]?.penaltyUserInfo
                      ?.email
                  }
                </p>
              </div>
            </div>
          </ModalHeader>

          <ModalBody>
            {selectedLeave ? (
              <>
                <p className="mb-1">
                  {moment(Number(selectedLeave?.createdAt)).format(
                    "dddd, Do MMMM YYYY, h:mm:ss a"
                  )}
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <b className="fw-bold">
                    Application for{" "}
                    {leaveTypeList?.find(
                      (l) => l?.value === selectedLeave?.leave_type
                    )?.label || "Unknown"}{" "}
                    leave
                  </b>
                  <Badge
                    className="text-white"
                    color={
                      selectedLeave.leave_status === "Pending" ||
                      selectedLeave.leave_status === "Denied"
                        ? "danger"
                        : "success"
                    }
                  >
                    {selectedLeave.leave_status}
                  </Badge>
                </div>
                <p>
                  <b>Start:</b>{" "}
                  {moment(selectedLeave.start_date).format("DD MMMM YYYY")}
                </p>
                <p>
                  <b>End:</b>{" "}
                  {moment(selectedLeave.end_date).format("DD MMMM YYYY")}
                </p>
                <p className="mt-3">
                  <b>Reason:</b> <br />
                  {selectedLeave.leave_reason}
                </p>
              </>
            ) : (
              <p>Loading leave data...</p>
            )}
          </ModalBody>
        </Modal>
      </CardBody>
    </Card>
  );
}
